import { render, staticRenderFns } from "./SystemLog.vue?vue&type=template&id=32dc0870&scoped=true"
import script from "./SystemLog.vue?vue&type=script&lang=js"
export * from "./SystemLog.vue?vue&type=script&lang=js"
import style0 from "./SystemLog.vue?vue&type=style&index=0&id=32dc0870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc0870",
  null
  
)

export default component.exports